<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Historial</li>
</ol>

<h1 class="page-header"><i class="fas fa-history"></i> Historial</h1>

<div class="scrollable">
    @if(history){
    <panel [noButton]="true">

        <div class="row">
            <div class="col-xs-12 col-md-4 col-lg-3">
                Periodo Seleccionado
                <input type="month" class="form-control" [(ngModel)]="periodSelected"
                    (ngModelChange)="getPeriod()">
            </div>
            <div class="col-xs-12 col-md-4">
                Tipo de Certificación
                <ng-select  [items]="groups" [(ngModel)]="groupSelected" bindLabel="name"
                    (ngModelChange)="getPeriod()"></ng-select>
            </div>
            <div class="col-xs-12 col-md-4 col-lg-3 d-flex justify-content-end align-items-end">
                <button class="btn btn-primary btn-sm" (click)="openPeriod()"><i class="fas fa-book-open pr-5"></i> Abrir Periodo</button>
            </div>
        </div>
        <table class="table table-sm my-5">
            <thead>
                <tr>
                    <th class="text-center">Entidad</th>
                    <th class="text-center">Realizado</th>
                    <th class="text-center">Validado</th>
                    <th class="text-center">Fecha Límite</th>
                    <th class="text-center">Puntaje</th>
                    <th class="text-center"><i class="fas fa-cogs"></i></th>
                </tr>
            </thead>
            <tbody>
                @for(entity of entities; track $index){
                <tr>
                    <td>{{ entity.code }} - {{ entity.name }}</td>
                    @if(entity.record){
                    <td class="text-center"><span
                            class="badge bg-{{ entity.record?.realized ? 'success' : 'warning' }} fs-10px"
                            ngbTooltip="{{entity.record?.realizedUser?.displayName || '—'}}{{entity.record?.realized ? ' - ' + ($safeNavigationMigration(entity.record?.realized) | date: 'dd/MM/yyyy') : ''}}">
                            <i class="fas {{ entity.record?.realized ? 'fa-check' : 'fa-minus' }}"></i></span></td>
                    <td class="text-center"><span
                            class="badge bg-{{ entity.record?.signedStatus ? 'success' : entity.record?.signedStatus === false ? 'danger' : 'warning' }} fs-10px"
                            ngbTooltip="{{entity.record?.signedUser?.displayName || '—'}}{{entity.record?.signedDate ? ' - ' + ($safeNavigationMigration(entity.record?.signedDate) | date: 'dd/MM/yyyy') : ''}}">
                            <i
                                class="fas {{ entity.record?.signedStatus ? 'fa-check' : entity.record?.signedStatus === false ? 'fa-times' : 'fa-minus' }}"></i></span>
                    </td>
                    <td class="text-center align-middle">{{ $safeNavigationMigration(entity.record?.expiration) | date: 'dd/MM/yyyy' }}
                    </td>
                    <td class="text-center align-middle"> <span
                            class="badge badge-score bg-{{entity.record?.score < 50 ? 'danger': entity.record?.score < 70 ? 'warning' : 'success'}} fs-10px">{{
                            $safeNavigationMigration(entity.record?.score) | number: "1.0-2" }}</span>
                    </td>
                    <td class="text-center">
                        <button class="btn btn-xs btn-primary mx-2" (click)="review(entity)"
                            ngbTooltip="Revisar Evaluación"><i class="fas fa-eye"></i></button>
                        <button class="btn btn-xs btn-primary mx-2" (click)="reopen(entity)"
                            ngbTooltip="Modificar fecha límite"><i class="fas fa-unlock"></i></button>
                        <button class="btn btn-xs btn-danger mx-2" (click)="reset(entity)"
                            ngbTooltip="Restablecer formulario"><i class="fas fa-undo"></i></button>
                    </td>
                    }
                    @else{
                    <td colspan="5" class="text-center">No hay registros</td>
                    <td class="text-center">
                        <button class="btn btn-xs btn-primary mx-2" (click)="openPeriod(entity)"
                            ngbTooltip="Abrir Periodo"><i class="fas fa-book-open"></i></button>
                    </td>
                    }
                </tr>
                }
            </tbody>
        </table>


    </panel>
    }
</div>
